import React from 'react';
import { Question } from 'talent_matching/types';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import Container from '@grnhse/seedling/lib/birch/components/container';
import { Body, Label } from '@grnhse/seedling/lib/birch/typography';
import { withLocalePrefix } from 'shared/utils/translation';
import styled from 'styled-components';

const t = withLocalePrefix('talent_matching.panel.application');

const StyledContainer = styled(Container)`
  padding: 8px 16px;
  border: unset;
`;

type Props = {
  questions: Array<Question> | undefined;
  type: string;
};

const Questions = ({ questions, type }: Props) => {
  if (!questions || questions.length === 0) {
    return null;
  }

  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={1}>
        <Body medium>{t(type)}</Body>
      </Stack>
      <Stack spacing={2}>
        {questions.map((question, i) => (
          <Stack spacing={1} key={i}>
            <Label>{question.question_label}</Label>
            <StyledContainer filled>
              <Body
                className="pii-blur"
                dangerouslySetInnerHTML={{
                  __html: question.answer || '--',
                }}
              />
            </StyledContainer>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default Questions;
